<!--
 * @Author: v_hllhe
 * @Date: 2022-12-21 10:41:43
 * @LastEditors: v_hllhe
 * @LastEditTime: 2022-12-27 16:21:50
 * @Description:
-->
<template>
  <div id="head_top">
    <div class="head">
      <div class="title">供应商人员画像</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/styles/convert-viewport";

#head_top {
  width: 100%;
  position: relative;
  height: vh(100);
  .head {
    width: 100%;
    height: vh(100);
    line-height: vh(100);
    background: url("~@/assets/personnel-large/headTop.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: vh(-100);
    animation: headAnimation 0.5s linear forwards;
  }
  .title {
    text-align: center;
    height: vh(40);
    font-family: TencentSansW7;
    font-size: vw(36);
    color: #2960d4;
    letter-spacing: 1px;
    line-height: vh(90);
  }
}
@keyframes headAnimation {
  from {
    top: vh(-100);
  }

  to {
    top: vh(0);
  }
}
</style>
